<template>
  <div>
    <b-container>
      <FormulateForm v-model="formValues"
        class="form-wrapper"
        @submit="onSubmit"
        name="dailyNoShowForm"
        :invalid-message="invalidMessage"
        #default="{ isLoading }"
      > 
        <h2 class="mt-5 mb-4">Daily No-show Report</h2>
        <b-row class="no-ride-form">
          <b-col md="4">
            <FormulateInput
                label="No-show Date:"
                type="date"
                name="date"
                @blur-context="updateSelections"
                :value="today()"
                v-model="noShowDate"
                :max="today()"
                :validation="[
                    ['^required'],
                ]"
            /></b-col>
          <b-col md="4">
            Vehicle Number:
            <v-select class="mt-2"
              v-model="selectedVehicle"
              :options="vehicleList"
              :reduce="vehicle => vehicle.bus_number"
              @input="updateSelections"
              label="bus_number"
              placeholder="Please select the vehicle number"
            />
            <formulateInput hidden name="vehicle"  v-model="selectedVehicle" validation='required'/>
          </b-col>
          <!-- <b-col md="4">
            Route Number:
            <v-select class="mt-2"
              v-model="selectedRoute"
              :options="routeList" 
              :reduce="route => route.number"
              @option:selected="updateSelections"
              label="number"
              taggable
              placeholder="Please select the route number."
            />
            <formulateInput hidden name="route"  v-model="selectedRoute" validation='required'/>
          </b-col> -->
          <b-col md="4">
              School or Program Name
              <v-select class="mt-2" 
                :options="schoolList" 
                label="name" 
                v-model="selectedSchool"
                :reduce="school => school.code"
                @input="updateSelections"
                placeholder="Please select a school or program"/>
              <FormulateInput type="hidden" name="school" v-model="selectedSchool" validation="^required"/>
          </b-col>
          <b-col md="12" class="mt-3">
            No-show students
            <v-select
              name="students"
              :disabled="!formValues.date || !formValues.school"
              v-model="selectedStudents"
              :options="studentList"
              :getOptionLabel="student => student.first_name +' '+ student.last_name"
              :placeholder="(formValues.date && formValues.school) ? 'Please select no-show students here.' : 'Please fill out the fields above before selecting students.'"
              multiple
              :select-on-key-codes="[188, 13, 9]"
            />
          </b-col>
            <!-- <b-col md="12" class="textarea">
              <FormulateInput
                type="textarea"
                name="selectedStudentNames"
                v-model="selectedStudentNames"
                validation-name="Student Names"
                :validation="[['^required'],]"
                disabled
                placeholder="Please use the search box above to search for the student names"
              />
              <FormulateInput
                type="hidden"
                name="selectedStudents"
                v-model="selectedStudents"
              />
            </b-col> -->
            <b-col><FormulateInput
                type="group"
                name="students"
              ><b-row>
                <b-col md="12" v-if="selectedStudents.length">
                  <p class="form-text text-muted mt-4">
                    Please select the transportation directions for selected students.
                  </p>
                </b-col>
                <FormulateInput
                  class="ml-3 mr-3"
                  v-for="student in selectedStudents"
                  :key="student.internal_id"
                  :name="student.internal_id"
                  :label="`${student.first_name} ${student.last_name} didn't ride` "
                  type="radio"
                  :options="{I: 'inbound (to school/facility)', O: 'outbound (from school/facility)', B: 'both' }"
                  validation="required"
                  validation-name="Direction"
                />
              </b-row>
            </FormulateInput></b-col>

        </b-row>
        <b-row>
            <b-col xs="12" class="text-center mt-3 mb-3">
              <FormulateErrors />
              <FormulateInput
                class="mt-3"
                type="submit"
                :disabled="isLoading"
                :label="isLoading ? 'Loading...' : 'Submit'"
                validation-behavior="live"
                help="this is a help"
                />
            </b-col>
        </b-row>
      </FormulateForm>
      Endpoint Data: {{ formValues }} <p></p>
    </b-container>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import { getStudent, getBus, postNewDailyNoShowForm, getBuilding } from '../services/api.js';

  export default {
    components: { },
    data() {
      return {
        formValues: {},
        noShowDate: "",
        vehicleList: [],
        studentList: [],
        schoolList: [],

        selectedVehicle: "",
        selectedRoute: "",
        selectedStudents: [],
        selectedSchool: "",
        submitTime: ""
      }
    },
    methods: {
      today() {
          var today = new Date();
          var month = today.getMonth() + Number(1);
          if (month < 10) {
              month = '0'+month;
          }
          var date = today.getDate();
          if (date < 10) {
              date = '0'+date;
          }
          return today.getFullYear() +'-'+ month +'-'+ date
      },
      async onSubmit () {
        this.formValues.submitTime = Date()
        let clonedFormValues = cloneDeep(this.formValues);
        for (const [key, value] of Object.entries(clonedFormValues)){
          if (Array.isArray(value) &&  value.length === 1)
            clonedFormValues[key] = value[0]
        }
        let parsedFormValues = []
        for (const [key, value] of Object.entries(clonedFormValues.students)){
          parsedFormValues.push({"student": key, "event_date":this.noShowDate, "event_type":value})
        }
        try {
          let response = await postNewDailyNoShowForm(parsedFormValues)
          console.log('response', response)
          if (response.status !== 201){
            //  check for response.status
            throw new Error(response);
          }
          let body = await response.data; // or .json() or whatever
          console.log(body)
          // process body
          alert('All validation complete, form submitted.')
          this.$router.go()
        } catch (error) {
          alert(`Form submission failed! ${error.response.data}`)
          console.log(error)
        }
      },
      invalidMessage(fields) {
        const fieldNames = Object.keys(fields)
        const listOfNames = fieldNames.map(fieldName => fieldName.replace('_', ' '))
        return `Oops! There are some errors above. Invalid fields: ${listOfNames}`
      },
      getDate(){
        return new Date(this.formValues.date).toISOString()
      },
      updateSelections(){
        let date = this.formValues.date ? this.formValues.date : '';
        // eslint-disable-next-line
        let route = this.selectedRoute ? this.selectedRoute : '';
        getStudent(date)
            .then(result => result.data)
            .then(result => {
                this.studentList = result
            }, error => {
                console.error(error);
            });
        getBus()
            .then(result => result.data)
            .then(result => {
                this.vehicleList = result
            }, error => {
                console.error(error);
            });
        getBuilding()
            .then(result => result.data)
            .then(result => {
                this.schoolList = result
            }, error => {
                console.error(error);
            });
      },
    },
    mounted() {
        this.updateSelections()
    },
  }
</script>
<style>
    .no-ride-form div .formulate-input {
        margin-bottom: 7px;
    }
    .textarea .formulate-input div textarea {
      height: 300px;
      margin-top: 40px;
    }
</style>
